export enum DeliveryType {
  Delivery = 0,
  Collection = 10
}
